<template>
    <CContainer>
        <h6>
            Esta sección le permite validar la información del Pedido que se realizó. Puede eliminar items, cancelar el Pedido, devolverse al catálogo y continuar agregando items o simplemente confirmarlo como está.
        </h6>
        <CCard class="mt-4">
            <CCardHeader class="p-5">
                <CRow>
                    <CCol sm="6">
                        <CForm>
                            <CRow>
                                <CCol col="10">
                                    <CInput
                                    :value.sync="pursharseOrder"
                                    :horizontal="true"
                                    label="Orden Compra #:"
                                    addLabelClasses="text-muted font-weight-bold col-lg-6 col-sm-12" 
                                    addInputClasses="col-lg-6 col-sm-12"
                                    />
                                </CCol>
                            </CRow>
                            <CRow>
                                <CCol col="10">
                                    <CInput
                                    :value.sync="comments1"
                                    :horizontal="true"
                                    label="Comentarios: "
                                    addLabelClasses="text-muted font-weight-bold col-sm-12" 
                                    addInputClasses="col-sm-12"
                                    />
                                    <CInput
                                    :value.sync="comments2"
                                    :horizontal="true"
                                    addLabelClasses="text-muted font-weight-bold col-sm-12" 
                                    addInputClasses="col-sm-12" 
                                    />
                                </CCol>
                            </CRow>
                        </CForm>
                    </CCol>
                    <CCol sm="6">
                        <CRow class="align-self-center">
                            <CCol class="mr-3 mb-3">
                                <CRow class="font-weight-bold"><CCol sm="6">Vr. Mercancia:</CCol><CCol align="right" sm="6">	${{formatter.format(cart.productsCost)}}</CCol></CRow>
                                <CRow class="font-weight-bold"><CCol sm="6">Vr. IVA:</CCol><CCol align="right" sm="6">	${{formatter.format(cart.IVACost)}}</CCol></CRow>
                                <CRow class="font-weight-bold"><CCol sm="6">Vr. ImpConsumo:</CCol><CCol align="right" sm="6">	${{formatter.format(cart.consTax)}}</CCol></CRow>
                                <CRow class="font-weight-bold" style="font-size:1.5em">
                                    <CCol sm="6">Total Pedido:</CCol>
                                    <CCol align="right" sm="6">
                                      <span v-if="(cart.productsCost + cart.IVACost + cart.consTax) > budgetValue" class="text-danger font-weight-bold">
                                        ${{ formatter.format(cart.productsCost + cart.IVACost + cart.consTax, 0) }}
                                      </span>
                                      <span v-if="(cart.productsCost + cart.IVACost + cart.consTax) <= budgetValue" class="text-dark font-weight-bold">
                                        ${{ formatter.format(cart.productsCost + cart.IVACost + cart.consTax, 0) }}
                                      </span>
                                    </CCol>
                                </CRow>
                            </CCol>
                        </CRow>
                        <CRow>
                            <CInputFile
                                @change="fileChange"
                                label="Adjuntar orden de compra: "
                                placeholder=""
                                :horizontal="true"
                                addLabelClasses="text-muted font-weight-bold col-sm-12" 
                                addInputClasses="col-sm-12" 
                            />
                        </CRow>
                    </CCol>
                </CRow>
                
                <CRow class="mt-5" align="center">
                    <CCol sm="4" class="mb-2">
                        <a class="btn btn-dark" href="#" @click="resetCart()">Cancelar Pedido</a>
                    </CCol>
                    <CCol sm="4" class="mb-2">
                        <CLink class="btn btn-dark" to="/cliente/movimientos/pedidos">Continuar Pedido</CLink>
                    </CCol>
                    <CCol sm="4" class="mb-2">
                        <CButton 
                          v-if="(cart.productsCost + cart.IVACost + cart.consTax) <= budgetValue"
                          color="dark" 
                          :disabled="(cartSize== 0) || (dependency.id_Dependencia.length == 0)" 
                          :class="(cartSize == 0) || (dependency.id_Dependencia.length == 0) ? 'disabled' : ''"
                          @click="confirmationModal = true" >
                          Confirmar Pedido
                        </CButton>
                        <p>
                            <span v-if="(dependency.id_Dependencia.length == 0)" class="text-danger" style="font-size:0.5em;">
                                No hay una dependencia asignada
                            </span>
                            <span v-if="(cartSize == 0)" class="text-danger" style="font-size:0.5em;">
                                No hay items en el carrito
                            </span>
                        </p>
                    </CCol>
                </CRow>
            </CCardHeader>
            <CCardBody>
                <CDataTable
                    :items="cart.items"
                    :fields="fields"
                    :items-per-page-select="{label:'Productos por página', values: [10, 20, 50]}"
                    :items-per-page="10"
                    :pagination="true"
                    hover>
                        <template #cantidad="{item}">
                            <td >
                                <CInput
                                    onkeydown="return !isNaN(Number(event.key)) || event.key == 'ArrowRight' || event.key == 'ArrowLeft' || event.key == 'ArrowDown' || event.key == 'ArrowUp' || (parseInt(event.target.value/10) > 1)"
                                    @input="(value) => { updateQuantity(value, item) }"
                                    :value.sync="item['cantidad']"
                                    min="1"
                                    type="number"/>
                                <!-- {{(item['cantidad'])}} -->
                                <!-- <CRow>
                                    <CCol align="center" col>
                                        <a href="#" class="badge badge-dark" @click="removeProductFromCart(item)">
                                            <CIcon name="cil-minus" size="sm"/>
                                        </a>
                                    </CCol>
                                    <CCol align="center" sm="6">
                                        <span class="align-middle font-weight-bold">{{item['cantidad']}}</span>
                                    </CCol>
                                    <CCol align="center" col>
                                        <a href="#" class="badge badge-dark" @click="addProductToCart(item)">
                                            <CIcon name="cil-plus" size="sm"/>
                                        </a>
                                    </CCol>    
                                </CRow> -->
                            </td>
                        </template>
                        <template #vrUnidad="{item}">
                            <td align="right">{{formatter.format(coefAccIVA(item).realCost)}}</td>
                        </template>
                        <template #vrTotal="{item}">
                            <td align="right">

                                {{
                                    formatter.format(
                                        coefAccIVA(item).realCost *
                                        parseFloat(item['cantidad']),
                                        0
                                    )
                                }}
                            </td>
                        </template>
                        <template #delete="{item, index}">
                            <td>
                                <CRow>
                                    <CCol sm="6">
                                        <CButton
                                            color="dark"
                                            square
                                            size="sm"
                                            @click="toggleComments(item, index)"
                                            class="mb-2">
                                            <CIcon name="cil-comment-square"></CIcon>
                                        </CButton>
                                    </CCol>
                                    <CCol sm="6">
                                        <CButton color="danger"
                                            square
                                            size="sm" 
                                            @click="deleteItem(item)">
                                            <CIcon name="cil-trash"></CIcon>
                                        </CButton>
                                    </CCol>

                                </CRow>
                            </td>
                        </template>
                        <template #details="{item}">
                            <CCollapse :show="Boolean(item._toggled)" class="mt-2 p-3" sm="12">
                                  <CTextarea 
                                    label="Comentarios: "
                                    v-on:keyup="updateComments($event, item)"
                                    :value.sync="item['comentarios']"
                                    :description="(item['comentarios']).length+ ' carácteres'"/>
                              
                              </CCollapse>
                        </template>
                    </CDataTable>
            </CCardBody>
        </CCard>
    <CModal
            title=""
            color="dark"
            :show.sync="confirmationModal"
            :centered="true"
            :closeOnBackdrop="false"
            :backdrop="true"
            >
            <template v-slot:header>
                <h4>Agregar Pedido</h4>
            </template>
            <template v-slot:body-wrapper>
                <CContainer align="center" class="p-4">                    
                    <p>
                       ¿Confirma que desea agregar este pedido?                   
                    </p>
                </CContainer>

            </template>
            <template v-slot:footer>
                <CContainer  align="center">
                    <CButton
                        color="success"
                        square 
                        class="mr-2 d-inline-block"
                        @click="createOrder()">
                        <CIcon name="cil-plus"/>
                        <span class="align-middle">Aceptar</span>
                        </CButton>
                        <CButton
                          color="secondary"
                          square 
                          class="mr-2 d-inline-block"
                          @click="confirmationModal=false">
                        <CIcon name="cil-x"/>
                        <span class="align-middle">Cancelar</span>
                        </CButton>
                </CContainer>
            </template>
        </CModal>
        <CElementCover  v-show="loading"/>
  </CContainer>
</template>
<script>
  import CONSTANTS from '../../constants'  
  import { coefAccIVA, coefConsTax, formatter, toBase64 } from '../../general'
  import { grabaPedido } from '../../api'

  const fields = [
        { 
            key: 'codigo', 
            label: 'Código', 
            _style:'text-align:center;'
        },
        { 
            key: 'descripcion', 
            label: 'Descripción', 
            _style:'text-align:center;'
        },
        { 
            key: 'referencia', 
            label: 'Presentación', 
            _style:'text-align:center;'
        },
        { 
            key: 'cantidad', 
            label: 'Cantidad',
            _style: 'width:20%;text-align:center;'
        },
        { 
            key: 'vrUnidad', 
            label: 'Vr. Unidad', 
            _style:'text-align:center;'
        },
        { 
            key: 'vrTotal', 
            label: 'Vr. Total', 
            _style:'text-align:center;'
        },
        { 
            key: 'delete', 
            label: '', 
            _style: 'width:10%;text-align:center;'
        }
    ]
  export default {
    name: 'OrderCart',
    data(){
        return {
          formatter,
          loading: false,
            fields,
            pursharseOrder: '',
            comments1: '',
            comments2: '',
            buyOrderFile: [],
            confirmationModal: false,
            budgetValue: 0
        }
    },
    methods: {
      coefAccIVA,
      coefConsTax,
      deleteItem(product) {
            this.$store.commit('popProductFromCart', product)
            this.$store.commit('calculateProductsCost')
            this.$store.commit('calculateIVACost')
            this.$store.commit('calculateConsTax')
      },
      updateQuantity(value, item){
            
            let fValue = 0
            if (value.toString().length && (Number(value) > 0)) {
                fValue = value                
            } else {
                const sItem = this.cart.items.find(product => item['id_Producto'] === product['id_Producto'])
                sItem['cantidad'] = 1
                this.$set(sItem, 'cantidad', 1)
                this.$nextTick(() => { })
            }

            this.$store.commit('updateItemQuantity', [
                    fValue,
                    item
                ])
            this.$store.commit('calculateProductsCost')
            this.$store.commit('calculateIVACost')
            this.$store.commit('calculateConsTax')  
        },
      resetCart(){
        this.$store.commit('resetCart')
        this.$router.push({path: '/cliente/movimientos/pedidos'})
      },
      async createOrder(){
        try {
          this.loading = true
          this.confirmationModal = false
            
          const fileBase64 = await this.toBase64(this.buyOrderFile).then(file => file)          
          
          const response = await grabaPedido(
            this,
            this.$store.state.user.data.id_Directorio,
            this.dependency.id_Dependencia,
            this.$store.state.user.data.id_Usuario,
            this.cart.items,
            this.fileExtension,
            fileBase64,
            this.pursharseOrder,
            this.comments1,
            this.comments2
          )
          console.log(response)
          this.$router.push({path:'/cliente'})
          this.$store.commit('setAlert', {
            color: "success",
            message: CONSTANTS.messages.successfulAction,
            show: 5
          })
          this.$store.commit('resetCart')

        } catch (error) {
          this.$store.commit('setAlert', {
            color: "danger",
            message: CONSTANTS.messages.notDoneAdd,
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      toggleComments(item){
        const sItem = this.cart.items.find(product => item['id_Producto'] === product['id_Producto'])
        this.$set(sItem, '_toggled', !item._toggled)
        this.$nextTick(() => { })
      },
      updateComments(event, product){
        const text_size = (event.target._value.toString()).length
        if (text_size > 500) {
          this.$store.commit('updateItemComments', [
                      (event.target._value.toString()).slice(0, 500),
                      product
                  ])
          
        } else {
          this.$store.commit('updateItemComments', [
                      event.target._value,
                      product
                  ])
        }
      },
      addProductToCart(product){
        this.$store.dispatch('addProductToCart', product)
      },
      removeProductFromCart(product){
        this.$store.dispatch('removeProductFromCart', product)
      },
      fileChange(files){
          this.buyOrderFile = files
        //   console.log(files)
      },
      toBase64
    },
    computed: {
      cart(){
        return this.$store.state.cart
      },
      dependency(){
        return this.$store.state.user.dependency
      },
      cartSize(){
          return this.cart.items.reduce(((acc, item) => {return Number(acc) + Number(item['cantidad'])}), 0)
      },
      fileExtension(){
        if (this.buyOrderFile[0]) {
            // return this.buyOrderFile[0].name.split(".")[1] ? this.buyOrderFile[0].name.split(".")[1] : ""
            return this.buyOrderFile[0].name
          } else {
            return ""
          }
      }
    },
    mounted() {
      this.budgetValue = this.$store.state.user.dependency.valorPresupuesto
    }
  }
</script>